/**
 * @Desription: 方法
 * @Author: netstar.sjj
 * @Date: 2021-10-26 16:05:00
 * @names: NSUtils
*/
import NSOAuthCode from '../ns-oauthcode';//授权码管理
import NSSort from '../ns-sort/index';//排序管理
import NSQueryManager from '../ns-query-manager/index';//查询管理
import valueConverManager from './value-conver-manager';//值转换管理
import urlManager from './url-manager'; //地址管理
import browserVersion from './browser-version';//浏览器读取版本信息
import ajaxManager from './ajax-manager';//ajax管理
import formatTree from './format-tree';//格式化树结构
import htmlCodeManager from './html-code-manager';//html
import reEntryDialogManager from './reentry-dialog-manager';
import {downloadFunc} from './download';//下载
import {deleteObjectStateFunc} from './delete-objectstate';//删除objectState字段
declare const window:any;
namespace NSUtils{
    export interface ObjectType{
        getObject(s: string): Object;//验证值
    }
    export const deleteAllObjectState:Function = deleteObjectStateFunc;
    export const sort:any = NSSort;//定义排序
    export const query:any = NSQueryManager; //查询管理
    export const valueConvertManager:any = valueConverManager;
    export const getUrlPara:Function = urlManager.getUrlPara;//获取url参数
    export const getAPIUrl:Function = urlManager.getAPIUrl;//获取api地址
    export const getWebUrl:Function = urlManager.getWebUrl;//获取web地址
    export const getUrl:Function = urlManager.getUrl;//根据指定的url地址输出完整的访问路径
    export const resetServerUrl:any = urlManager.resetServerUrl;//重置地址
    export const OAuthCode:any = NSOAuthCode;//授权码
    export const Browser:any = browserVersion();//浏览器
    export const getBrowserVersion:Function = browserVersion;
    export const getResultByExpresstion = valueConverManager.getResultByExpresstion;
    export const moreAjax:Function = ajaxManager.moreAjax;
    export const setAjaxConfig:Function = ajaxManager.setAjaxConfig;
    export const ajax:Function = ajaxManager.ajax;
    export const logAjax:Function = ajaxManager.logAjax;
    export const defaultAjaxError:Function = ajaxManager.defaultAjaxError;
    export const maskConver:Function = valueConverManager.maskConver;//掩码转换
    export const objectConver:Function = valueConverManager.objectConver;//对象转换 {a:"1", b:"2"} -> a=1&b=2
    export const dataFormat:any = formatTree;//格式化树结构
    export const htmlCode:any = htmlCodeManager;
    export const reEntryDialog:any = reEntryDialogManager;
    export const download:Function = downloadFunc;
    export function deepCopy(obj:any){
        if (obj == null) { return null }
        let result:any = Array.isArray(obj) ? [] : {};
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && !(obj[key] instanceof window.jQuery)) {
                    result[key] = deepCopy(obj[key]); // 如果是对象，再次调用该方法自身
                } else {
                    result[key] = obj[key];
                }
            }
        }
        return result;
    }//深度克隆
    export function getFunction(funcStr:any) {
        let rex = /function\((.*?)\)\{([\s\S]*)\}/;
        let match = funcStr.match(rex);
        if(match == null){
            return false;
        }
        let paramsStr = match[1];
        let funcContent = match[2];
        let functionFunc = new Function(paramsStr, funcContent);
        return functionFunc;
    }
    export function getFormatParameterJSON(variableJson:any,variableData:any,isShowError?:boolean){
        /***入参：
         *	variableJson:object  			包含变量的输出格式 例如:{"id":"{cid}"};
        * 	variableData:object  			当前数据，用于读取变量值
        *
        ***出参
        * return JSON/Object  如果返回参数为false 则说明取值不成功
        ***/

        let json = variableJson;
        let data = variableData;
        isShowError = typeof (isShowError) == "boolean" ? isShowError : true;
        // 添加systemInfo相关参数
        if (typeof (data) == "object") {
            data = deepCopy(variableData);
            if (Array.isArray(data)) {
               
            }else{
                data.systemInfo = window.NetstarMainPage && typeof (window.NetstarMainPage.systemInfo) == "object" ? window.NetstarMainPage.systemInfo : {};
                if(window.jQuery.isEmptyObject(data.systemInfo)){
                    let cacheDataObj:any = window.store.get('loginProperty');//登录成功之后获取系统用户信息
                    if(typeof(cacheDataObj)=='object'){
                        data.systemInfo = cacheDataObj;
                    }
                }
            }
        }
        let resultJson = NSUtils.deepCopy(json);
        let markRegexp = /\{(.*?)\}/;
        let markRegArrexp = /\[(.*?)\]/;

        let markRegexp1 = /\{\{(.*?)\}\}/;

        let error:any = null;
        function getValue(_vals:any, _valArr:any, _index:number) {
            let resVal:any = '';
            if (Array.isArray(_vals)) {
                resVal = [];
                for (let i = 0; i < _vals.length; i++) {
                    resVal[i] = _vals[i][_valArr[_index]];
                    if (_index < _valArr.length - 1) {
                        if (typeof (resVal[i]) == "object") {
                            resVal = getValue(resVal[i], _valArr, _index + 1);
                        } else {
                            resVal = error;
                        }
                    }
                }
            } else {
                resVal = _vals[_valArr[_index]];
                if (_index < _valArr.length - 1) {
                    if (typeof (resVal) == "object") {
                        resVal = getValue(resVal, _valArr, _index + 1);
                    } else {
                        resVal = error;
                    }
                }
            }
            return resVal;
        }
        function replaceVariable(_json:any, _keyField:string,_keyFieldDepth:number) {
            for(let key in _json){
                let value:any = _json[key];
                if (typeof (value) == 'string') {
                    //如果是字符串则有可能是要替换的字符，其他类型不用处理
                    const isMarkObjExp = markRegexp.test(value);
                    const isMarkArrExp = markRegArrexp.test(value);
                    const isMarkObjExp1 = markRegexp1.test(value);

                    if (isMarkObjExp || isMarkArrExp || isMarkObjExp1) {
                        let variableName:any;//获取变量名
                        if(isMarkArrExp){
                            variableName = value.match(markRegArrexp)[1];
                        }else if(isMarkObjExp1){
                            variableName = value.match(markRegexp1)[1];
                        }else{
                            variableName = value.match(markRegexp)[1];
                        }
                        let variableNameArray = variableName.split('.');
                        let variableValue:any = getValue(data, variableNameArray, 0);
                        if (variableValue == error || typeof (variableValue) == 'undefined') {
                            variableValue = error;
                            if (isShowError) {
                                console.error('变量 {' + variableName + '} 不存在');
                            }
                        }
                        if(Array.isArray(variableValue)) {
                            // 数组中存在对象则表示返回数组
                            let isObj = false;
                            for (let i = 0; i < variableValue.length; i++) {
                                if (typeof (variableValue[i]) == 'object') {
                                    isObj = true;
                                }
                            }
                            // 判断是否存在undefined 或 null 如果存在一律改为 'null'
                            for (let i = 0; i < variableValue.length; i++) {
                                if (variableValue[i] == error || typeof (variableValue[i]) == 'undefined') {
                                    if (isObj) {
                                        variableValue[i] = null;
                                    } else {
                                        // 改为无论是否对象都是null 因为api如果不是文本则报错 cy 20201220
                                        variableValue[i] = null;
                                        // variableValue[i] = 'null';
                                    }
                                }
                            }
                            if (!isObj) {
                                //如果该值是数字且长度为1 ，则不转为文本 也就是 1,2的形式 cy 20201117
                                if(variableValue.length == 1 && typeof(variableValue[0]) == 'number'){
                                    variableValue = variableValue[0]
                                }else{
                                    //如果数组中包含null 则该数组为nullArray，后台接收会报400  cy 20201220 start ------
                                    let isNullArray = false;
                                    if(Array.isArray(variableValue)){
                                        for(var i=0; i<variableValue.length; i++){
                                            if(variableValue[i] == null){
                                                isNullArray = true;
                                            }
                                        }
                                    }
                                    if(isNullArray){
                                        variableValue = null;
                                    }else{
                                        if(isMarkObjExp){
                                            variableValue = variableValue.toString();
                                        }
                                    }
                                    // variableValue = variableValue.toString();
                                    // cy 20201220 end ------

                                }
                            }
                        }

                        if (_keyFieldDepth == 0) {
                            //如果是第一层，直接读取就可以
                            resultJson[key] = variableValue;
                        } else {
                            //如果是第二层或以上，需要按照深度拼接
                            let currentObj:any = {};
                            let keyFieldArray = _keyField.split('.');
                            for (let roI = 0; roI < _keyFieldDepth; roI++) {
                                currentObj = resultJson[keyFieldArray[roI + 1]];
                            }
                            currentObj[key] = variableValue;
                        }
                    }
                } else if (typeof (value) == 'object') {
                    //如果是object 则可能继续进入替换
                    replaceVariable(_json[key], _keyField + '.' + key, _keyFieldDepth + 1);
                } else {
                    //其他类型不处理
                }
            }
        }
        replaceVariable(json, '', 0);
        return resultJson;
    }
    export function parseFilters(exp:any){
        let inSingle = false;
        let inDouble = false;
        let inTemplateString = false;
        let inRegex = false;
        let curly = 0;
        let square = 0;
        let paren = 0;
        let lastFilterIndex = 0;
        let c:any, prev:any, i:any, expression:any;

        for (i = 0; i < exp.length; i++) {
            prev = c;
            c = exp.charCodeAt(i);
            if (inSingle) {
                if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
            } else if (inDouble) {
                if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
            } else if (inTemplateString) {
                if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
            } else if (inRegex) {
                if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
            } else if (
                c === 0x7C && // pipe
                exp.charCodeAt(i + 1) !== 0x7C &&
                exp.charCodeAt(i - 1) !== 0x7C &&
                !curly && !square && !paren
            ) {
                if (expression === undefined) {
                    // first filter, end of expression
                    lastFilterIndex = i + 1;
                    expression = exp.slice(0, i).trim();
                }
            } else {
                switch (c) {
                    case 0x22: inDouble = true; break         // "
                    case 0x27: inSingle = true; break         // '
                    case 0x60: inTemplateString = true; break // `
                    case 0x28: paren++; break                 // (
                    case 0x29: paren--; break                 // )
                    case 0x5B: square++; break                // [
                    case 0x5D: square--; break                // ]
                    case 0x7B: curly++; break                 // {
                    case 0x7D: curly--; break                 // }
                }
                if (c === 0x2f) { // /
                    let j = i - 1;
                    let p = (void 0);
                    // find first non-whitespace prev char
                    for (; j >= 0; j--) {
                        p = exp.charAt(j);
                        if (p !== ' ') { break }
                    }
                }
            }
        }

        if (expression === undefined) {
            expression = exp.slice(0, i).trim();
        }
        return expression;
    }
    /**
     * 把带有{{}}的内容值转换为特定的值
     * @param  {any} str 要转换的格式 如{{str}}
     * @param  {any} regexpData 转换值 如{str:'23',aa:'sdf'}
     */
    export function getLabelsByRegexpMatch(str:any,regexpData:any){
        if(typeof(str)!='string'){return str;}//如果当前值不是字符串格式直接返回
        let tokens = [];
        let tagRE = /\{\{((?:.|\n)+?)\}\}/g;
        let lastIndex = tagRE.lastIndex = 0;
        let match, index, tokenValue;
        let returnStr = '';
        while ((match = tagRE.exec(str))) {
            index = match.index;
            // push str token
            if (index > lastIndex) {
                tokenValue = str.slice(lastIndex, index)
                tokens.push(tokenValue);
            }
            let exp:any = parseFilters(match[1].trim());
            if(Array.isArray(regexpData[exp])){
                //当前是数组
            } else if (exp.indexOf('.') > -1) {
                //读取到的里面包含.
                let getValue = function(ps:any) {
                    let top = regexpData;
                    for (let i = 0; i < ps.length - 1; i++) {
                        if (!top[ps[i]]) {
                            top[ps[i]] = {};
                        }
                        top = top[ps[i]];
                    }
                    return top;
                }
                let expArray = exp.split('.');
                let listData = getValue(expArray);
                let listField = expArray[expArray.length - 1];
                let appenHtml:any = tokens[tokens.length - 1];
                if(Array.isArray(listData)) {
                    for (let listI = 0; listI < listData.length; listI++) {
                        let expHtml = appenHtml;
                        if (listI == listData.length - 1) {
                            expHtml = '';
                        }
                        tokens.push(listData[listI][listField] + expHtml);
                    }
                } else {
                    tokens = [listData[listField]];
                }
            } else {
                let expStr = '';
                if (regexpData.hasOwnProperty(exp) && regexpData[exp] != undefined) {
                    expStr = regexpData[exp];
                }
                tokens.push(expStr);
            }
            lastIndex = index + match[0].length;
        }
        if (lastIndex < str.length) {
            tokenValue = str.slice(lastIndex)
            tokens.push(tokenValue);
        }
        for (let i = 0; i < tokens.length; i++) { returnStr += tokens[i]; }
        return returnStr;
    }
    /**
     * 验证表达式是否存在
     * @param  {object} data 待验证数据
     * @param  {RegExp} regExp 表达式格式(正则) 默认：/\{(.*?)\}/
    */
    export function validExprExists(data: any, regExp: any){
        regExp = typeof(regExp) == "undefined" ? /\{(.*?)\}/ : regExp;
        let isHave = false;
        for(let key in data){
            if(typeof(data[key]) == "string"){
                isHave = regExp.test(data[key]);
                if(isHave){
                    break;
                }
            }
        }
        return isHave;
    }
    export function setDefaultValues(sourceJSON, _defaultValuesJSON){
        /**
         * 	sourceJSON:object  			当前设置
         * 	_defaultValuesJSON:object 	默认设置
         **/
        if (typeof (sourceJSON) == 'undefined') {
            sourceJSON = {};
        }
        window.jQuery.each(_defaultValuesJSON, function (key, value) {
            if (typeof (sourceJSON[key]) == 'undefined') {
                switch (typeof (value)) {
                    case 'undefined':
                        break;
                    case 'object':
                        var emptyObject = {};
                        if (window.jQuery.isArray(value)) {
                            emptyObject = [];
                        }
                        sourceJSON[key] = window.jQuery.extend(true, emptyObject, value);
                        break;
                    default:
                        sourceJSON[key] = value;
                        break;
                }
            }
        })
    };
    export function newGuid(params: { len: number, format: string, prefix: string }) {
        params = typeof(params) == "object" ? params : {
            len: 32, format: 'N2', prefix: 'ns'
        };
        let len = typeof (params.len) == 'number' ? params.len : 32;
        let format = typeof (params.format) == 'number' ? params.format : 'N2';
        let prefix = typeof (params.prefix) == 'number' ? params.prefix : 'ns';
		let guid = "";
		for (let i = 1; i <= len; i++) {
			let n = Math.floor(Math.random() * 16.0).toString(16);
			guid += n;
			if (format != 'N2') {
				if ((i == 8) || (i == 12) || (i == 16) || (i == 20)) {
					guid += "-";
				}
			}
		}
        if(prefix){
            guid =  prefix + guid;
        }
		return guid;
    };
    export function getUseConfig() {
        
    };
    export function setUseConfig() {
        
    };
}
export default NSUtils;